import Image from 'next/legacy/image';
import Link from 'next/link';
import {
  AspectRatio,
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Heading,
  Text,
  Grid,
  GridItem
} from '@chakra-ui/react';
import { GridPatternDark, LayoutContainer } from '@components/common';
import { useEffect, useState } from 'react';

export function Customer(): JSX.Element | null {
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    setShouldRender(true);
  }, []);

  // Workaround to prevent `Hydration failed because the initial UI does not match what was rendered on the server.`
  if (!shouldRender) return null;

  return (
    <LayoutContainer verticalPadding="md" pos="relative">
      <Flex justifyContent="center" alignItems="center" mx={16}>
        <Box pos="relative">
          <AspectRatio
            ratio={1400 / 1190}
            w="1000px"
            pos="absolute"
            top="-200px"
            left="460px"
            pointerEvents="none"
            draggable={false}
            userSelect="none"
          >
            <GridPatternDark />
          </AspectRatio>

          <Heading
            size="md"
            color="gray.400"
            mb={4}
            textAlign={{ base: 'center', md: 'left' }}
          >
            Customers
          </Heading>

          <Heading
            size="h1"
            maxW="680px"
            mb={{ base: 8, md: 6 }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            You're in <br></br>
            <Heading size="h1" color="primary.500">
              {' '}
              Great Company
            </Heading>
          </Heading>

          <Flex
            gap={{ base: 8, md: 12 }}
            maxW={{ lg: '600px' }}
            mb={10}
            flexDir={{ base: 'column', md: 'row' }}
          >
            <Text
              fontSize="xl"
              flex={1}
              textAlign={{ base: 'center', md: 'left' }}
              maxW={{ lg: '80%' }}
            >
              Clerk's secure, easy-to-use, and extensible platform allows
              innovators to innovate.
            </Text>
          </Flex>

          <Flex justifyContent={{ base: 'center', md: 'left' }}>
            <Link href={process.env.NEXT_PUBLIC_DASHBOARD_URL as string}>
              <Button
                w={{ base: 'full', sm: '225px' }}
                variant="base"
                fontSize={'md'}
              >
                Start Building
              </Button>
            </Link>
          </Flex>
        </Box>

        <AspectRatio
          height="520px"
          width="636px"
          display={{ base: 'none', lg: 'inline-flex' }}
        >
          <Image src="/images/logos/logos.svg" alt="" layout="fill" />
        </AspectRatio>
      </Flex>
      <Flex
        bg="white"
        mt={16}
        borderRadius="16px"
        boxShadow="0px 64px 64px -48px rgba(28, 30, 81, 0.08)"
        justifyContent="space-evenly"
        pos="relative"
        p="32px"
      >
        <Grid
          templateColumns={{
            base: 'repeat(1, 1fr)',
            md: 'repeat(7, 1fr)'
          }}
        >
          <GridItem h="12vh" zIndex={10}>
            <Flex
              h="12vh"
              flexDir="column"
              justifyContent={'center'}
              alignItems="center"
              px={8}
            >
              <Heading>6k+</Heading>
              <Text whiteSpace={'nowrap'}>Applications Deployed</Text>
            </Flex>
          </GridItem>
          <Center>
            <Divider
              orientation={'vertical'}
              display={{ base: 'none', md: 'inline-flex' }}
            />
          </Center>
          <GridItem h="12vh" zIndex={10}>
            <Flex
              h="12vh"
              flexDir="column"
              justifyContent={'center'}
              alignItems="center"
              px={8}
            >
              <Heading>500k+</Heading>
              <Text whiteSpace={'nowrap'}>Users</Text>
            </Flex>
          </GridItem>
          <Center>
            <Divider
              orientation={'vertical'}
              display={{ base: 'none', md: 'inline-flex' }}
            />
          </Center>
          <GridItem h="12vh" zIndex={10}>
            <Flex
              h="12vh"
              flexDir="column"
              justifyContent={'center'}
              alignItems="center"
              px={8}
            >
              <Heading>2M+</Heading>
              <Text whiteSpace={'nowrap'}>Sessions Secured</Text>
            </Flex>
          </GridItem>
          <Center>
            <Divider
              orientation={'vertical'}
              display={{ base: 'none', md: 'inline-flex' }}
            />
          </Center>
          <GridItem h="12vh" zIndex={10}>
            <Flex
              h="12vh"
              flexDir="column"
              justifyContent={'center'}
              alignItems="center"
              px={8}
            >
              <Heading>24/7</Heading>
              <Text whiteSpace={'nowrap'}>Support Coverage</Text>
            </Flex>
          </GridItem>
        </Grid>
      </Flex>
    </LayoutContainer>
  );
}
